import { render, staticRenderFns } from "./Alerts.component.vue?vue&type=template&id=39a86a96"
import script from "./Alerts.component.vue?vue&type=script&lang=js"
export * from "./Alerts.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports